module.exports = __webpack_public_path__ + "media/images/Avis-2-08113e684456b40a46031d20e575e467.svg";